export type WithTableData = { tableData?: { id?: number } }

export function getTableElementIndex<E extends WithTableData>(element: E): number | false {
  if ('tableData' in element && 'id' in element.tableData) {
    const oldIndex = element.tableData.id
    if (oldIndex >= 0) {
      return oldIndex
    }
  }
  return false
}

export function updateTableElement<E extends WithTableData>(newElement: E, oldElement: E, elements: E[]): E[] {
  const oldIndex = getTableElementIndex(oldElement)
  if (oldIndex !== false) {
    const newElements = [...elements]
    newElements[oldIndex] = newElement
    return newElements
  }
  return elements
}

export function deleteTableElement<E extends WithTableData>(element: E, elements: E[]): E[] {
  const oldIndex = getTableElementIndex(element)
  if (oldIndex !== false) {
    const newElements = [...elements]
    newElements.splice(oldIndex, 1)
    return newElements
  }
  return elements
}
